import moment from 'moment'
// import debug from 'util'
export default {
  loadReasons (state, value) {
    state.reasons = value
  },
  loadScheduleOrders (state, value) {
    state.registeredScheduleOrders = value
  },
  toggleAlterDateModal (state, value) {
    state.alterDateModal = value
  },
  toggleScheduleOrdersModal (state, value) {
    state.scheduleOrdersModal = value
  },
  toggleSendEmailModal (state, value) {
    state.sendEmailModal = value
  },
  toggleDateConfigModal (state, value) {
    state.dateConfigModal = value
  },
  toggleScheduleDetailsModal (state, value) {
    state.scheduleEditing = false
    state.scheduleDetailsModal = value
    if (!value) {
      state.selectedSchedule = {
        item: null,
        id: '',
        dates: [],
        status: 0,
        sent: false,
        condominium: {
          id: '',
          cnpj: '',
          name: '',
          address: '',
          addressNumber: '',
          neighborhood: '',
          city: '',
          state: '',
          zipCode: '',
          administrator: ''
        },
        disponibility: {
          capacity: 1,
          interval: null,
          start: null,
          end: null
        },
        code: ''
      }
    }
  },
  toggleTimeScheduleModal (state, value) {
    if (state.selectedSchedule.disponibility === null) {
      state.selectedSchedule.disponibility = {
        capacity: 1,
        interval: null,
        start: null,
        end: null
      }
    }
    state.timeScheduleModal = value
  },
  updateReason (state, value) {
    state.selectedSchedule.idReason = value
  },
  toggleLoadingCanceled (state, value) {
    state.loadingCanceled = value
  },
  toggleLoadingFinished (state, value) {
    state.loadingFinished = value
  },
  toggleLoadingSaved (state, value) {
    state.loadingSaved = value
  },
  toggleAlteredScheduleSaving (state, value) {
    state.alteredScheduleSaving = value
  },
  selectScheduleItem (state, payload) {
    if (JSON.parse(JSON.stringify(state.selectedSchedule.item)) !== JSON.parse(JSON.stringify(payload))) {
      state.selectedSchedule = {
        // item: payload,
        id: '',
        dates: [],
        status: 0,
        sent: false,
        condominium: {
          id: '',
          cnpj: '',
          name: '',
          address: '',
          addressNumber: '',
          neighborhood: '',
          city: '',
          state: '',
          zipCode: '',
          administrator: ''
        },
        disponibility: {
          capacity: 1,
          interval: null,
          start: null,
          end: null
        },
        code: ''
      }
    } else {
      state.searchCnpj = ''
      state.selectedSchedule.item = null
    }
  },
  selectScheduleItens (state, payload) {
    const _category = state.selectedSchedule.category
    if (typeof state.selectedSchedule.itens === 'undefined' || JSON.parse(JSON.stringify(state.selectedSchedule.itens)) !== JSON.parse(JSON.stringify(payload))) {
      state.selectedSchedule = {
        itens: payload,
        id: '',
        category: _category,
        dates: [],
        status: 0,
        sent: false,
        condominium: {
          id: '',
          cnpj: '',
          name: '',
          address: '',
          addressNumber: '',
          neighborhood: '',
          city: '',
          state: '',
          zipCode: '',
          administrator: ''
        },
        disponibility: {
          capacity: 1,
          interval: null,
          start: null,
          end: null
        },
        code: ''
      }
    } else {
      state.searchCnpj = ''
      state.selectedSchedule.itens = []
    }
  },
  newSearchCondominiumCnpj (state, value) {
    state.searchCnpj = ''
    state.selectedSchedule.condominium = {
      id: '',
      cnpj: '',
      name: '',
      address: '',
      addressNumber: '',
      neighborhood: '',
      city: '',
      state: '',
      zipCode: '',
      administrator: ''
    }
  },
  newSchedule (state, value) {
    state.selectedItens = []
    state.scheduleDetailsModal = true
    state.errorDisponibilityInterval = false
    state.searchCnpj = ''
    state.selectedSchedule = {
      id: '',
      category: '',
      itens: value || [],
      dates: [],
      status: 0,
      sent: false,
      condominium: {
        id: '',
        cnpj: '',
        name: '',
        address: '',
        addressNumber: '',
        neighborhood: '',
        city: '',
        state: '',
        zipCode: '',
        administrator: ''
      },
      disponibility: {
        capacity: 1,
        interval: null,
        start: null,
        end: null
      },
      code: ''
    }
  },
  errorSearchCnpj (state, value) {
    state.errorSearchCnpj = value
  },
  appendNewSchedule (state, payload) {
    state.registeredSchedules.unshift(payload)
  },
  updateRegisteredSchedules (state, payload) {
    if (payload !== true) {
      state.registeredSchedules = state.registeredSchedules.map(elem =>
        elem.id === payload.id ? payload : elem
      )
    }
  },
  updateScheduleCode (state, value) {
    state.selectedSchedule.code = value
  },
  updateScheduleDate (state, value) {
    if (!value) {
      value = []
    }
    state.selectedSchedule.dates = value
  },
  toggleLoadingCondominium (state, value) {
    state.loadingCondominium = value
  },
  loadCondominium (state, payload) {
    state.selectedSchedule.condominium = payload
  },
  loadSchedules (state, payload) {
    state.registeredSchedules = [].concat(state.registeredSchedules, payload)
  },
  selectSchedule (state, payload) {
    state.selectedSchedule = payload
    // deep clone comparação
    state.alteredSchedule = JSON.parse(JSON.stringify(payload))
  },
  toggleScheduleEditing (state) {
    state.scheduleEditing = !state.scheduleEditing
    // deep clone
    state.selectedSchedule = JSON.parse(JSON.stringify(state.alteredSchedule))
  },
  cancelChange (state) {
    // deep clone
    state.selectedSchedule = JSON.parse(JSON.stringify(state.alteredSchedule))
  },
  updateSearchCnpj (state, value) {
    state.searchCnpj = value
  },
  updateCapacity (state, value) {
    state.selectedSchedule.disponibility.capacity = value
  },
  updateInterval (state, value) {
    if (value) {
      state.errorDisponibilityInterval = false
    }
    state.selectedSchedule.disponibility.interval = value
  },
  updateDisponibilityStart (state, value) {
    if (moment.duration(value).asHours() > moment.duration(state.selectedSchedule.disponibility.end).asHours()) {
      state.selectedSchedule.disponibility.start = value
      state.selectedSchedule.disponibility.end = null
    } else {
      state.selectedSchedule.disponibility.start = value
    }
  },
  updateDisponibilityEnd (state, value) {
    state.selectedSchedule.disponibility.end = value
  },
  updateSearchSchedule (state, value) {
    state.searchSchedule = value
  },
  resetAgendamento (state) {
    state.registeredSchedules = []
  },
  resetItemForScheduled (state) {
    state.selectedItens = []
  },
  addItemForScheduled (state, payload) {
    state.selectedItens.push(payload)
  },
  removeItemForScheduled (state, payload) {
    state.selectedItens = state.selectedItens.filter((item) => {
      return item.id !== payload.id
    })
  },
  removeScheduleItem (state, payload) {
    state.selectedSchedule.itens = state.selectedSchedule.itens.filter((item) => {
      return item.id !== payload.id
    })
    if (state.selectedSchedule.itens.length === 0) {
      state.selectedItens = []
      state.selectedSchedule.category = ''
    }
  },
  setSelectedScheduleCategory (state, payload) {
    state.selectedSchedule.category = payload
  },
  setSelectScheduleItens (state, payload) {
    state.selectedSchedule.itens = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/agendamento/mutations.js